export default {
    title: 'Export'
}